
// @flow
export const CLASS_TYPE_COMMON: 'class' = 'class';
export const CLASS_TYPE_GPDS: 'gpd' = 'gpd';
export const CLASS_TYPE_CAMP: 'camp' = 'camp';
